import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const AdminSingInApi = createAsyncThunk("admin/signin-user", async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${baseUrl}user/api/v1//signin-user`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Admin Signin API Response:", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error in the admin login :", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to admin login");
  }
});
